import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const pageStyle: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #f4c542 0%, #fffbe6 100%)',
  fontFamily: 'Inter, Arial, sans-serif',
};

const cardStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: 18,
  boxShadow: '0 8px 32px rgba(60,60,60,0.18)',
  padding: '2.5rem 2.5rem 2rem 2.5rem',
  minWidth: 340,
  maxWidth: '90vw',
  textAlign: 'center',
};

const iconStyle: React.CSSProperties = {
  background: '#4BB543',
  borderRadius: '50%',
  width: 64,
  height: 64,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 18px auto',
  boxShadow: '0 2px 8px rgba(75,181,67,0.15)'
};

const errorIconStyle: React.CSSProperties = {
  ...iconStyle,
  background: '#d32f2f',
};

const buttonStyle: React.CSSProperties = {
  marginTop: 24,
  background: '#f4c542',
  color: '#222',
  border: 'none',
  borderRadius: 6,
  padding: '12px 32px',
  fontWeight: 600,
  fontSize: '1.1rem',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(244,197,66,0.10)',
  transition: 'background 0.2s',
};

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending');
  const [message, setMessage] = useState('Verifying your email...');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Verification token is missing.');
      return;
    }
    fetch(`https://nova-media-backend.vercel.app/api/auth/verify-email?token=${token}`)
      .then(async (res) => {
        const data = await res.json();
        if (res.ok) {
          setStatus('success');
          setMessage('Your email has been verified! You can now login.');
        } else {
          setStatus('error');
          setMessage(data.message || 'Verification failed.');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Network error. Please try again.');
      });
  }, [searchParams]);

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        {status === 'pending' && (
          <>
            <div style={{...iconStyle, background: '#f4c542'}}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></svg>
            </div>
            <h2 style={{ color: '#222', fontWeight: 700, fontSize: '1.5rem', marginBottom: 8 }}>Verifying...</h2>
            <p style={{ color: '#444', fontSize: '1.1rem' }}>{message}</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={iconStyle}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 11 17 4 10" /></svg>
            </div>
            <h2 style={{ color: '#222', fontWeight: 700, fontSize: '1.5rem', marginBottom: 8 }}>Email Verified!</h2>
            <p style={{ color: '#444', fontSize: '1.1rem' }}>{message}</p>
            <button style={buttonStyle} onClick={() => navigate('/')}>Go to Login</button>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={errorIconStyle}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>
            </div>
            <h2 style={{ color: '#d32f2f', fontWeight: 700, fontSize: '1.5rem', marginBottom: 8 }}>Verification Failed</h2>
            <p style={{ color: '#444', fontSize: '1.1rem' }}>{message}</p>
            <button style={buttonStyle} onClick={() => navigate('/')}>Go to Login</button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail; 